export const COUNT_MESSAGE = 10;
